import React, { Component } from 'react'
import {
  Form,
  Input,
  Button,
  DatePicker,
  // Upload,
  // Icon,
  Radio,
  // message
} from 'antd'
import qs from 'query-string'
import { Helmet } from 'react-helmet'
import _ from 'lodash'
import moment from 'moment'
import { push } from '../history'
import './UserForm.scss'
import { graphql } from '../graphql'

const RadioGroup = Radio.Group
const RadioButton = Radio.Button
const FormItem = Form.Item

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

// const beforeUpload = (file) => {
//   const isImage = file.type === 'image/*';
//   if (!isImage) {
//     message.error('ไม่ใช่ไฟล์รูปภาพ');
//   }
//   const isLt2M = file.size / 1024 / 1024 < 2;
//   if (!isLt2M) {
//     message.error('ขนาดรูปต้องไม่เกิน 2MB');
//   }
//   return isImage && isLt2M;
// }

class RegistrationForm extends Component {
  state = {
    confirmDirty: false,
    imageUrl: null,
    isRegistered: false,
    me: {}
  }

  componentWillMount = () => {
    this.handleGetProfile()
  }

  handleGetProfile = () => {
    const token = qs.parse(location.hash.split('?').pop()).token || localStorage.getItem('token')
    console.log('token:', token)
    graphql(`
      query {
        me() {
          id, firstname, lastname, gender, birthDate, tel, email
        }
      }`).then((response) => {
        const me = _.get(response, 'data.me') || {}
        console.log('me:', me)
        const { form } = this.props
        if (me.id) {
          this.setState({ isRegistered: true })
          const fields = ['firstname', 'lastname', 'gender', 'birthDate', 'tel', 'email', 'image']
          _.forEach(fields, (fieldName) => {
            form.getFieldDecorator(fieldName)
          })
          form.setFieldsValue({
            firstname: me.firstname || '',
            lastname: me.lastname || '',
            gender: me.gender || '',
            birthDate: moment(me.birthDate || ''),
            tel: me.tel || '',
            email: me.email || '',
          })
        }
      })
    const { form } = this.props
    form.getFieldDecorator('keys', { initialValue: [] })
  }

  handleImageChange = (info) => {
    if (info.file.status === 'done') {
      getBase64(info.file.originFileObj, (imageUrl) => this.setState({ imageUrl }));
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      const { isRegistered } = this.state
      console.log('this.state', this.state)
      if (!err) {
        graphql(`
          mutation {
            ${isRegistered ? 'updateMe' : 'registerUser'}(
              firstname: "${values.firstname}",
              lastname: "${values.lastname}",
              gender: "${values.gender}",
              birthDate: "${values.birthDate}",
              tel: "${values.tel}",
              email: "${values.email}"
            ) {
              id, firstname, lastname
            }
          }
        `).then(() => { push('/doses') })
        console.log('Received values of form: ', values)
      }
    })
  }

  handleConfirmBlur = (e) => {
    const value = e.target.value
    this.setState({ confirmDirty: this.state.confirmDirty || !!value })
  }

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true })
    }
    callback()
  }

  render() {
    const { getFieldDecorator } = this.props.form
    // const { imageUrl } = this.state
    const formItemLayout = {
      labelCol: { xs: { span: 24 }, sm: { span: 6 }, },
      wrapperCol: { xs: { span: 24 }, sm: { span: 14 } }
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 14, offset: 6 },
      }
    }
    return (
      <Form onSubmit={this.handleSubmit} style={{ padding: '15px' }}>
        <Helmet>
          <title>ข้อมูลส่วนตัว</title>
        </Helmet>
        <h2 className="title">
          ข้อมูลส่วนตัว
        </h2>
        <br />
        <FormItem
          {...formItemLayout}
          label="ชื่อ"
          hasFeedback
        >
          {getFieldDecorator('firstname', { rules: [{ required: true, whitespace: true, message: 'ใส่ชื่อจริง' }] })(
            <Input placeholder="ชื่อ (ไม่ต้องมีคำนำหน้าชื่อ)" />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="นามสกุล"
          hasFeedback
        >
          {getFieldDecorator('lastname', { rules: [{ required: true, whitespace: true, message: 'ใส่นามสกุล' }] })(
            <Input placeholder="นามสกุล" />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="วันเกิด"
        >
          {getFieldDecorator('birthDate', { rules: [{ required: true, message: 'ใส่วันเกิด' }] })(
            <DatePicker placeholder="วันเกิด" />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="เพศ"
        >
          {getFieldDecorator('gender', { initialValue: 'male' })(
            <RadioGroup>
              <RadioButton value="male">ชาย</RadioButton>
              <RadioButton value="female">หญิง</RadioButton>
            </RadioGroup>
          )}
        </FormItem>
        {/*<FormItem
          {...formItemLayout}
          label="รูปภาพ"
        >
          {getFieldDecorator('image')(
            <Upload
              className="avatar-uploader"
              name="avatar"
              showUploadList={false}
              action="//jsonplaceholder.typicode.com/posts/"
              beforeUpload={beforeUpload}
              onChange={this.handleImageChange}
            >
              {imageUrl ?
                <img src={imageUrl} alt="" className="avatar" /> :
                <Icon type="plus" className="avatar-uploader-trigger" />
              }
            </Upload>
          )}
        </FormItem>*/}
        <FormItem
          {...formItemLayout}
          label="เบอร์โทร"
          hasFeedback
        >
          {getFieldDecorator('tel', { rules: [{ required: true, whitespace: true, message: 'ใส่เบอร์โทรศัพท์' }] })(
            <Input placeholder="เบอร์โทรศัพท์" />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="อีเมล์"
          hasFeedback
        >
          {getFieldDecorator('email')(
            <Input placeholder="อีเมล์ (ไม่จำเป็นต้องใส่)" />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button className="submit-button" type="primary" htmlType="submit" size="large">ยืนยันข้อมูล</Button>
        </FormItem>
      </Form>
    )
  }
}

const WrappedRegistrationForm = Form.create()(RegistrationForm)
export default WrappedRegistrationForm



// WEBPACK FOOTER //
// ./src/UserForm/UserForm.js